import { ProductPresentation } from '@models/product';

export const documentsWithoutTheftCoverage: Partial<ProductPresentation> = {
    docIPIDUrl: 'astra_IPID_Elektronik_Endkunden_EV_OD_2026.pdf',
    docAVBUrl: 'astra_AVB_Elektronik_Endkunden_EV_OD_2026.pdf',
    docAddInfoUrl: 'astra_Kundeninfo_Elektronik_Endkunden_EV_OD_2026.pdf',
    docAnzeigepflichtUrl: 'Obliegenheiten_und_vorvertragliche_Anzeigepflicht.pdf',
};
